import { Pipe, PipeTransform } from "@angular/core";
import { localize } from "@gtmhub/localization";
import dayjs from "@webapp/shared/libs/dayjs";

@Pipe({
  name: "lastReplyOn",
  standalone: true,
})
export class LastReplyOnPipe implements PipeTransform {
  public transform(input: string): string {
    if (dayjs(input).isSame(dayjs(), "day")) {
      return localize("last_reply_today");
    }

    if (dayjs(input).add(1, "day").isSame(dayjs(), "day")) {
      return localize("last_reply_yesterday");
    }

    return localize("last_reply_on", { replyDate: dayjs(input).format("DD MMM") });
  }
}
